import { transparentize } from 'polished'
import styled from 'styled-components'

import { helpers } from 'styles'

type Props = {
	isDisabled: boolean
}

export const Item = styled.div<Props>`
	padding: 2px 6px;
	cursor: ${({ isDisabled }) => (isDisabled ? 'auto' : 'pointer')};
	color: ${helpers.color.input.text};
	font-size: 14px;
	font-family: ${helpers.font.family.base};

	&:hover > div {
		background-color: ${({ theme, isDisabled }) => (isDisabled ? theme.color.input.disabled : transparentize(0.6, theme.color.focus))};
	}
`
